import request from "../../utiles/axios";

/**
 * 查询用户
 * @param {*} data
 * @returns
 */
export function getPage(data) {
  return request({
    url: "/user/page",
    method: "post",
    data: data,
  });
}
/**
 * 查询机构树
 * @param {*} data
 * @returns
 */
export function getDeptTree(enableFlag) {
  return request({
    url: `/dept/deptTree?enableFlag=${enableFlag}`,
    method: "post"
  });
}
export function deptTreeByCompCode(compCode) {
  return request({
    url: `/dept/deptTreeByCompCode?compCode=${compCode}`,
    method: "post",
  });
}
/**
 * 新增修改用户
 * @param {*} data
 * @returns
 */
export function saveOrUpdate(data) {
  return request({
    url: "/user/saveOrUpdate",
    method: "post",
    data: data,
  });
}
/**
 * 用户启用/禁用切换
 * @param {*} data
 * @returns
 */
export function updateEnableFlag(data) {
  return request({
    url: "/user/updateEnableFlag",
    method: "post",
    data: data,
  });
}
/**
 * 重置密码
 * @param {*} id
 * @returns
 */
export function resetPw(data) {
  return request({
    url: "/user/resetPw",
    method: "post",
    data: data,
  });
}
